<template>
  <div class="modal-mask" @click="close">
    <div class="modal-content" style="width: 500px">
      <h2 class="title" v-show="!orderId">{{ title }}</h2>
      <h2 class="title-wx"  v-show="orderId"><img src="../../../static/images/weixin.png"/>{{title}}</h2>
      <div class="order-info" v-show="orderId">
        <div>
          <p>订单编号：{{orderId}} </p>
          <p>订单类型：{{orderType}}</p>
        </div>
        <div>
          <label>应付金额：</label>
          <span>￥{{price}}</span>
        </div>
      </div>
      <div class="pay-img" v-lazy-container="{ selector: 'img'}">
        <img class="erweima" :data-src='img' :data-loading='lazyImg'/>
        <div class="pay-result" v-if="showResult">
          <img src="../../../static/images/success.png"/>
          <span>支付成功</span>
        </div>
      </div>
      <div class="tip" v-show="orderId">
        <img src="../../../static/images/vip_ico02.png" />
        <div>
          请使用微信扫描<br>
          二维码完成支付
        </div>
      </div>
      <p v-show="!orderId && title=='在线客服'">微信扫一扫</p>
      <p v-show="!orderId && title=='在线客服'">添加客服微信咨询</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload } from 'vant';
Vue.use(Lazyload)
export default {
  name: "modal",
  props: {
    title: {
      type: String
    },
    img: {
      type: String
    },
    orderId: {
      type: String
    },
    orderType: {
      type: String
    },
    price: {
      type: String
    },
    showResult: {
      type: Boolean,
      default: false
    },
    resultType: {
      type: Number
    },
  },
  data() {
      return {
        lazyImg: require('../../../static/images/lazy_mid.png'),
      }
  },
  methods: {
    close() {
      this.$emit("close")
    }
  }
}
</script>

<style scoped lang="less">
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(40, 40, 40, 0.6);
  z-index: 60;

  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 360px;
    padding-bottom: 30px;
    background: #FFFFFF;
    transform: translate(-50%, -50%);
    border-radius: 16px;

    .title {
      font-size: 24px;
      font-weight: 500;
      margin-top: 40px;
      text-align: center;
    }
    .title-wx {
      font-size: 24px;
      font-weight: 500;
      margin-top: 20px;
      margin-left: 20px;
      img {
        width: 34px;
        height: 30px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .order-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-radius: 4px;
      font-size: 12px;
      background: #F7F7F7;
      margin: 10px 20px;
      p {
        margin-top: 10px;
      }
      span {
        color: #E70012;
      }
      div {
        p {
          text-align: left;
        }
      }
    }
    .tip {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      color: #ffffff;
      width: 170px;
      background: #405D86;
      margin: 10px auto 0;
      padding: 8px 30px;
      img {
        width: 26px;
        height: 26px;
      }
    }

    .pay-img {
      position: relative;
      display: block;
      width: 174px;
      height: 177px;
      margin: 35px auto 23px;
      .erweima {
        display: block;
        width: 100%;
        height: 100%;
      }

      .pay-result {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(255,255,255,0.9);
        text-align: center;

        img {
          display: block;
          width: 80px;
          height: 80px;
          margin: 40px auto;
        }

        span {
          display: block;
          font-size: 12px;
          margin-top: 16px;
          color: #282828;
        }
      }
    }

    p {
      font-size: 12px;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/modal.vue